module.exports = __webpack_public_path__ + "static/media/wappen_4c.6fc76f36.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/leader/wappen_4c.png
// module id = 836
// module chunks = 1